/**
 * @param data  Data is the direct result of a graphql query
 *
 * This function allows to process a list of navigations at once
 */
function allNavsResolver(data, locale = "fr") {
  const navigations = {}
  for (let nav in data) {
    navigations[nav] = navResolver(data[nav]).filter(n => n.locale === locale)
  }
  return navigations
}

/**
 * @param navigation  Navigation is a navigation object from a graphql query
 */
function navResolver(navigation) {
  return navigation.nodes.map(navNodeResolver)
}

/**
 * @param node  node is a navigation node, it may have nested pages
 */
function navNodeResolver(node) {
  let nested = []

  // check if node has children
  if (typeof node.children !== "undefined") {
    nested = node.children.map(navNodeResolver)
  } else if (typeof node.nested !== "undefined") {
    nested = node.nested.map(navNodeResolver)
  }

  return {
    ...node,
    ...node.page,
    nested,
  }
}

export { allNavsResolver, navResolver }
